import { defineMessages } from "react-intl";
import SharedIntlProviderHOC from '../../shared-components/hocs/sharedIntlProviderHOC';

const translationMessages = defineMessages({
  auTermsLabel: {
    id: 'hosting.account_country_data.terms_label_au',
    defaultMessage: 'How do I find my BSB and bank account number?'
  },
  caTermsLabel: {
    id: 'hosting.account_country_data.terms_label_ca',
    defaultMessage: 'How do I find my institution and/or transit number?'
  },
  euTermsLabel: {
    id: 'hosting.account_country_data.terms_label_eu',
    defaultMessage: 'How do I find my IBAN?'
  },
  ukTermsLabel: {
    id: 'hosting.account_country_data.terms_label_uk',
    defaultMessage: 'How do I find my sort code and/or account number?'
  },
  usTermsLabel: {
    id: 'hosting.account_country_data.terms_label_us',
    defaultMessage: 'How do I find my routing and/or account number?'
  }
});

const getCountryData = () => {
  const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
  return {
    STRIPE_AU: {
      terms_info_link: `https://support.peerspace.com/${zendeskLocale}/articles/10119446-how-do-i-find-my-bsb-and-bank-account-number`,
      terms_info_label: translationMessages.auTermsLabel,
      inputs: 'formInputsAU'
    },
    STRIPE_CA: {
      terms_info_link: `https://support.peerspace.com/${zendeskLocale}/articles/10119457-how-do-i-find-my-institution-and-or-transit-number`,
      terms_info_label: translationMessages.caTermsLabel,
      inputs: 'formInputsCA'
    },
    STRIPE_EU: {
      terms_info_link: `https://support.peerspace.com/${zendeskLocale}/articles/10119434-how-do-i-find-my-iban`,
      terms_info_label: translationMessages.euTermsLabel,
      inputs: 'formInputsEU'
    },
    STRIPE_UK: {
      terms_info_link: `https://support.peerspace.com/${zendeskLocale}/articles/10119456-how-do-i-find-my-sort-code-and-bank-account-number-uk-host-payouts`,
      terms_info_label: translationMessages.ukTermsLabel,
      inputs: 'formInputsUK'
    },
    STRIPE_US: {
      terms_info_link: `https://support.peerspace.com/${zendeskLocale}/articles/10119453-how-do-i-find-my-routing-and-account-number`,
      terms_info_label: translationMessages.usTermsLabel,
      inputs: 'formInputsUS'
    }
  };
};

export default getCountryData;
